import http from '@admin/http';
import { AxiosInstance } from 'axios';

function ctor({ http }: { http: AxiosInstance }) {
  return async (orderId: string, installmentId: string) => {
    const response = await http.post(
      `/lnpl/v1/orders/${orderId}/installments/${installmentId}/charge`, undefined,
      { validateStatus: () => true },
    );

    if (response.status > 299) {
      throw response.data;
    }
  };
}

export const chargeInstallment = ctor({ http });
